import React from 'react'
import { range, get, find } from 'lodash'
import PropTypes from 'prop-types'
import ReportTable from './ReportTable'

export default function Report(props) {

	const groups = []
	for (const categoryKey in props.categoryFilters) {
		if (get(props.categoryFilters, categoryKey, false)) {
			groups.push(categoryKey.substr(0, 1).toUpperCase())
		}
	}

	const groupsNames = {
		'E': 'Executive',
		'M': 'People Mgmt',
		'P': 'Professional',
		'S': 'Support',
	}

	const extraFiledTitles = {
		salary_p50: 'Salary P50 CR',
		salary_p75: 'Salary P75 CR',
		ttc_p50: 'TTC P50',
		ttc_p75: 'TTC P75',
		atc_p50: 'ATC P50',
		atc_p75: 'ATC P75',
		unvested_stock_options_p50: 'Equity P50',
		unvested_stock_options_p75: 'Equity P75',
	}

	const extraFields = []
	for (const fieldFilterKey in props.fieldFilters) {
		if (get(props.fieldFilters, fieldFilterKey, false)) {
			extraFields.push(fieldFilterKey)
		}
	}

	const getExtraFieldsValues = (data) => {
		const extraFieldsValues = []
		extraFields.forEach(fieldKey => {
			extraFieldsValues.push(data ? data[`avg_comp_${fieldKey}`] : '')
		})
		return extraFieldsValues
	}

	const levelsData = []
	const groupSummary = {}
	let currentTotalN = 0

	range(14).forEach(level => {
		const levelData = props.jobGrades.filter(hd => hd.hierarchy === level)
		const groupData = {}
		groups.forEach(g => {
			groupData[g] = {
				level: '',
				title: '',
				n: '',
			}
		})

		levelData.forEach(ld => {
			const groupKey = ld.job_grade.slice(0, 1)
			const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })
			groupData[groupKey] = {
				level: ld.job_grade,
				title: ld.job_title,
				n: dataInReport ? dataInReport.total : 0,
				extraFieldsValues: getExtraFieldsValues(dataInReport)
			}
			if (groupSummary[groupKey]) {
				groupSummary[groupKey].n += groupData[groupKey].n
			} else {
				groupSummary[groupKey] = { n: groupData[groupKey].n }
			}
		})
		levelsData.push(groupData)
	})

	const graphsDataByGrades = {}
	levelsData.forEach(level => {
		for (const grade in level) {
			if (!graphsDataByGrades[grade]) {
				graphsDataByGrades[grade] = []
			}
			if (level[grade].level !== '') {
				graphsDataByGrades[grade].push({ title: level[grade].level, count: level[grade].n })
			}
		}
	})

	Object.keys(groupSummary).forEach(key => {
		currentTotalN += groupSummary[key].n
	})

	return (
		<React.Fragment>
				<ReportTable
					groups={groups}
					extraFields={extraFields}
					extraFiledTitles={extraFiledTitles}
					levelsData={levelsData}
					groupsNames={groupsNames}
					groupSummary={groupSummary}
					currentTotalN={currentTotalN}
					graphsDataByGrades={graphsDataByGrades}
				></ReportTable>
		</React.Fragment>
	)
}

Report.propTypes = {
	reportData: PropTypes.array.isRequired,
	jobGrades: PropTypes.array.isRequired,
	fieldFilters: PropTypes.object.isRequired,
	categoryFilters: PropTypes.object.isRequired,
}
